import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    // 登录页
    path: '/login',
    component: () => import('@/views/LoginVue.vue'),
  },


  {
    // 主页
    path: '/index',
    component: () => import('@/views/MyIndex.vue'),
    redirect: '/index/user/management',
    children: [
      {
        // 概览
        path: '/overview',
        component: () => import('@/views/Overview.vue'),
      },
      {
        // 用户管理
        path: 'user',
        children: [
          {
            // 用户管理
            path: 'management',
            component: () => import('@/views/user/user/UserManagement.vue'),
          },
          {
            // 用户-角色管理
            path: 'role',
            component: () => import('@/views/user/role/RoleManagement.vue'),
          },
          {
            // 用户-部门管理
            path: 'dept',
            component: () =>
              import('@/views/user/department/DeptManagement.vue'),
          },
        ],
      },

      {
        // 车辆管理
        path: 'car',
        children: [
          {
            // 车辆-车辆登记
            path: 'registration',
            component: () =>
              import('@/views/car/registration/Registration.vue'),
          },

          {
            // 车辆-车组管理
            path: 'fleet',
            component: () => import('@/views/car/fleet/FleetManagement.vue'),
          },
          {
            // 车辆-车组管理-车组查看
            path: 'fleet/view',
            component: () =>
              import('@/views/car/fleet/components/FleetView.vue'),
          },

          {
            // 车辆-信号管理
            path: 'signal',
            component: () => import('@/views/car/signal/SignalManagement.vue'),
          },

          {
            // 车辆-车型管理
            path: 'type',
            component: () => import('@/views/car/type/CarType.vue'),
          },
        ],
      },
      {
        path: 'licence',
        children: [
          {
            path: 'software',
            component: () =>
              import('@/views/licence/software/SoftwareList.vue'),
          },
          {
            path: 'list',
            component: () => import('@/views/licence/list/LicenceList.vue'),
            // import("../components/licence/list/LicenceList.vue"),
          },
          {
            path: 'list/:id',
            component: () =>
              import('@/views/licence/list/detail/LicenceDetail.vue'),
          },
          {
            path: 'record',
            component: () => import('@/views/licence/record/RecordList.vue'),
          },
          {
            path: 'application',
            component: () =>
              import('@/views/licence/application/Application.vue'),
          },
          {
            path: 'approval',
            component: () => import('@/views/licence/approval/Approval.vue'),
          },
        ],
      },
    ],
  },

  {
    // 数据权限-修改账号信息
    path: '/index/user/management/AccountInformation',
    component: () =>
      import('@/views/user/account-information/AccountInformation.vue'),
  },
  {
    // 用户-部门管理-修改账号信息
    path: '/index/user/dept/AccountInformation',
    component: () =>
      import('@/views/user/account-information/AccountInformation.vue'),
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 全局路由守卫,设置访问的权限
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('obj');
  // let itemstr = token?.split(':')[2]
  // let myTime = Number(itemstr?.slice(0,itemstr.length-1))
  // let nowTime = new Date().getTime() // 当前时间戳

  //   如果访问的是'/login',直接放行
  if (to.path === '/login') return next();
  //   如果不存在token则直接跳转登录页面，反之放行
  // if (!token || (myTime < nowTime)) {
  //     return next('/login')
  if (!token) {
    return next('/login');
  } else {
    next();
  }
});

export default router;
